const DB_NAME = "wisham-db"
const STORE_NAME = "badge"

export function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)

    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" })
      }
    }

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

export async function getUnseenCount(): Promise<number> {
  const db = await openDB()
  const tx = db.transaction(STORE_NAME, "readonly")
  const store = tx.objectStore(STORE_NAME)

  return new Promise<number>((resolve) => {
    const request = store.get("unseenNotifications")
    request.onsuccess = () => resolve(request.result?.count || 0)
    request.onerror = () => resolve(0)
  })
}

export async function incrementUnseenCount(): Promise<number> {
  const db = await openDB()
  return new Promise<number>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite")
    const store = tx.objectStore(STORE_NAME)

    const getRequest = store.get("unseenNotifications")
    getRequest.onsuccess = () => {
      const current = getRequest.result?.count || 0
      store.put({ id: "unseenNotifications", count: current + 1 })
    }

    tx.oncomplete = () => resolve((getRequest.result?.count || 0) + 1)
    tx.onerror = () => reject(tx.error)
  })
}

export async function resetUnseenCount(): Promise<void> {
  const db = await openDB()
  return new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite")
    const store = tx.objectStore(STORE_NAME)
    store.put({ id: "unseenNotifications", count: 0 })
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })
}
